import feathers from "./index";

export const FacilityRecord = feathers.get("FacilityRecord");
export const BuildingRecord = feathers.get("BuildingRecord");
export const FloorRecord = feathers.get("FloorRecord");
export const InfographicRecord = feathers.get("InfographicRecord");
export const InvitationRecord = feathers.get("InvitationRecord");
export const MarkerTypeCategoryRecord = feathers.get("MarkerTypeCategoryRecord");
export const MarkerTypeRecord = feathers.get("MarkerTypeRecord");
export const MarkerRecord = feathers.get("MarkerRecord");
export const UserRecord = feathers.get("UserRecord");
export const PermissionRecord = feathers.get("PermissionRecord");
export const CurrentAccountRecord = feathers.get("CurrentAccountRecord");
export const PlanRecord = feathers.get("PlanRecord");
export const TrainingRecord = feathers.get("TrainingRecord");
export const GroupRecord = feathers.get("GroupRecord");



// WEBPACK FOOTER //
// ./src/feathers/records.js